import { useMapEvents } from "react-leaflet"
import { useState } from "react"

import type { FC, PropsWithChildren } from "react"

import { ZoomContext } from "./ZoomContext"

interface ZoomTrackerProps extends PropsWithChildren {
  initialZoom: number
}

export const ZoomTracker: FC<ZoomTrackerProps> = ({ children, initialZoom }) => {
  const [zoom, setZoom] = useState<number>(initialZoom)

  useMapEvents({
    zoomend: (e) => {
      setZoom(e.target.getZoom())
    },
    load: (e) => {
      setZoom(e.target.getZoom())
    },
  })

  return <ZoomContext.Provider value={zoom}>{children}</ZoomContext.Provider>
}
